module.exports = __webpack_public_path__ + "static/media/fieldedge_logo.e6bbc1a4.png";